module.exports = __webpack_public_path__ + "static/img/cont59 (1).79c0932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (1).jpg
// module id = Z2hN
// module chunks = 0